import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import APIUsagesList from './components/APIUsagesList';
import APIUsagesByLayerList from './components/APIUsageByLayer';
import APIUsagesByServiceList from './components/APIUsageByService';
import APIUsagesByCollectionList from './components/APIUsageByCollection';

const APIUsages = () => {
  return (
    <Container>
      <Row>
        <Col lg={12} md={12}>
          <h3 className="page-title">API Usages Management</h3>
          <h3 className="page-subhead subhead">View API usages by users so far!</h3>
        </Col>
      </Row>
      <Row>
        <APIUsagesList />
      </Row>
      <Row>
        <Col lg={4}>
          <APIUsagesByServiceList />
        </Col>
        <Col lg={4}>
          <APIUsagesByCollectionList />
        </Col>
        <Col lg={4}>
          <APIUsagesByLayerList />
        </Col>
      </Row>
    </Container>
  );
};

export default APIUsages;